import { render } from "./AccountTypeSearch.vue?vue&type=template&id=64579985&scoped=true"
import script from "./AccountTypeSearch.vue?vue&type=script&lang=js"
export * from "./AccountTypeSearch.vue?vue&type=script&lang=js"

import "@/assets/css/table-resp.css?vue&type=style&index=0&id=64579985&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64579985"]])

export default __exports__